import { isDelayDaysValid } from '@/common/components/DelayDaysInput/helpers'
import { refundHoldModeValues } from '@/common/constants'

export const isPutRefundOnHoldValid = ({ mode, delayDays, reason }) => {
  const hasReason = Boolean(reason.trim())

  if (mode !== refundHoldModeValues.delayByDays) return hasReason

  return hasReason && isDelayDaysValid(delayDays)
}
